//React
import { useEffect, useState } from "react";

//Hooks
import { useApi } from "../hooks/useApi";
import { useMapInfo } from "../hooks/useMapInfo";
import { useMapUtil } from "../hooks/useMapUtil";

//Leaflet & geo
import { GeoJSON, Marker, useMapEvents } from 'react-leaflet';
import { LatLng, LatLngBounds } from "leaflet";
import { geoExpandBounds } from "../helpers/GeoHelper";

function MapCommuneLayer() {
    /**
     * Hooks
     */
    const { mapInfo, centerMap } = useMapInfo();
    const { createLoader, deleteLoader, isLoader } = useMapUtil();
    const { getCommunesGeoJSON } = useApi();
    const mapEvent = useMapEvents({
        //Detect zoom change
        zoomend: () => {
            setActualZoom(mapEvent.getZoom());
        },
        //Detect move change
        moveend: () => {
            setCenter(mapEvent.getCenter());
            setBounds(mapEvent.getBounds());
        }
    });

    /**
     * States
     */
    const [communes, setCommunes] = useState(null);
    const [layerKey, setLayerKey] = useState(0); //Pour forcer le rechargement du layer (voir useEffect)
    const [actualZoom, setActualZoom] = useState(0);
    const [center, setCenter] = useState<LatLng>(null);
    const [bounds, setBounds] = useState<LatLngBounds>(null);

    /**
     * useEffects
     */
    useEffect(() => {
        setLayerKey(layerKey + 1);
    }, [communes]);

    useEffect(() => {
        if(actualZoom >= 10 && actualZoom <= 16 && !isLoader('communes')) {
            createLoader('communes', 'Chargement des communes...');
            let newBounds = geoExpandBounds(bounds, 300);
            getCommunesGeoJSON(null, null, newBounds.toBBoxString())
                .then((data) => {
                    //On fusionne les features pour éviter les doublons
                    let features = communes==null?[]:communes.features;
                    data.features.forEach((feature) => {
                        let isAlreadyPresent = false;
                        for(let i = 0; i < features.length; i++) {
                            if(features[i].properties.code == feature.properties.code) isAlreadyPresent = true;
                        }
                        if(!isAlreadyPresent) {
                            features = [...features, feature];
                        }
                    });
                    setCommunes({
                        type: "FeatureCollection",
                        features: features
                    });
                    deleteLoader('communes');
                })
                .catch((error) => {
                    console.error(error);
                    deleteLoader('communes');
                });
        }
    }, [actualZoom, center, bounds]);

    if(!communes || actualZoom < 10 || actualZoom > 16) return (
        <>
        </>
    );

    /**
     * Handlers
     */
    const handleClickOnCommune = (e) => {
        let communeBounds = e.target.getBounds();
        let centerLon = communeBounds.getCenter().lng;
        let centerLat = communeBounds.getCenter().lat;
        
        centerMap({
            longitude: centerLon,
            latitude: centerLat
        }, 17);
    }

    const onEachCommune = (feature, layer) => {
        layer.on({
            click: handleClickOnCommune
        });
    }
    
    return (
        <>
            <GeoJSON
                key={layerKey}
                data={communes}
                style={{color: 'white'}}
                onEachFeature={onEachCommune}/>
        </>
    );
}

export default MapCommuneLayer;